var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-topic-panel",
    { attrs: { title: _vm.title, name: "reservation", tooltip: _vm.tooltip } },
    [
      !_vm.isFutureContract(_vm.contractId)
        ? _c(
            "router-link",
            {
              staticClass: "pega-text-link",
              attrs: {
                to: {
                  name: "scoutReservation",
                  params: { contractId: _vm.contractId, jobId: _vm.jobId },
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "boss-scoutandlike-text",
                  attrs: { "data-test": "link-text" },
                },
                [
                  _c("span", { staticClass: "wrap-block" }, [
                    _vm._v(_vm._s(_vm.reservationCount) + "件"),
                  ]),
                  _c("span", { staticClass: "wrap-block" }, [
                    _vm._v("(" + _vm._s(_vm.reservationUserCount) + "名)"),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }